exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".border[data-v-0357ed6b] {\n  border: 1px solid #c9c9c9;\n  margin-bottom: 5px;\n  padding: 5px 5px 5px 5px;\n}\n.title[data-v-0357ed6b] {\n  height: 25px;\n}\n.title .text[data-v-0357ed6b] {\n  font-weight: bold;\n  float: left;\n  line-height: 25px;\n}\n.title .action[data-v-0357ed6b] {\n  float: right;\n}\n", ""]);

// exports
